import { render, staticRenderFns } from "./ProjectSectionBackingInformation.vue?vue&type=template&id=24b6f8a2"
import script from "./ProjectSectionBackingInformation.vue?vue&type=script&lang=js"
export * from "./ProjectSectionBackingInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports